module.exports = __webpack_public_path__ + "img/white_family.1402b3ff.svg";